export default "Gå sammen på farvejagt i naturen – mon I kan finde farver nok til en hel regnbue?";